import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import graphql from 'api/graphql';
import { fetchGigyaJWTPromise } from 'api/gigya';
import { FAVORITE_ALL_STATIONS_SLUG, TILE_SIZES } from 'globalConst/const';
import Collection from 'components/Collection';
import EmptyStatePlaceholder from 'components/EmptyStatePlaceholder';
import { FAV_STATIONS_TITLE, FAV_STATION_SUBTITLE, FAV_STATION_TEXT } from './FavoriteCollection.const';
import { TILE_COMPONENT_TYPES } from 'components/TileComponent/TileComponent.const';
import logger from 'util/logger';

function FavoriteStationsCollection({ stations, isUserLoggedIn }) {
  const [favoriteStations, setFavoriteStations] = useState(null);
  useEffect(() => {
    let unmounted;
    async function fetchStations() {
      try {
        const jwtToken = await fetchGigyaJWTPromise();
        const gqlFavsStations = await graphql.fetchFavoriteStations(jwtToken, FAVORITE_ALL_STATIONS_SLUG);
        if (!unmounted) setFavoriteStations(gqlFavsStations || []);
      } catch (error) {
        logger.error('[FavoriteStationsCollection] Failed to fetch favorite stations from Universal API.', error);
      }
    }
    if (isUserLoggedIn) {
      fetchStations();
    }
    return () => {
      unmounted = true;
    };
  }, [stations, isUserLoggedIn]);

  return !isUserLoggedIn || (favoriteStations && favoriteStations.length === 0) ? (
    <EmptyStatePlaceholder title={FAV_STATIONS_TITLE} subtitle={FAV_STATION_SUBTITLE} text={FAV_STATION_TEXT} />
  ) : (
    <Collection
      collectionId="favoriteStations"
      items={favoriteStations}
      title={FAV_STATIONS_TITLE}
      rows={1}
      showCount
      tileComponent={TILE_COMPONENT_TYPES.STATION}
      swipe
      isComponentLoading={!favoriteStations}
      tileSizes={TILE_SIZES.SMALL}
    />
  );
}

FavoriteStationsCollection.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  stations: PropTypes.array.isRequired,
};

export default FavoriteStationsCollection;
